import { useEffect, useState } from 'react';
import { fetchFraseDelGiorno } from '../../lib/api';

/**
 * "Frase del giorno" — variante inline da incorporare accanto a un titolo.
 *
 * - Selezione deterministica per data (calcolata lato backend).
 * - Stile: corsivo, allineato a sinistra, piccolo grigio, separato da '|'.
 * - Nascosta in fase di caricamento e su errore.
 *
 * Cache: 1 fetch al mount.
 */
export default function FraseDelGiorno() {
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchFraseDelGiorno()
      .then((d) => { if (!cancelled) setData(d); })
      .catch(() => { /* silent */ });
    return () => { cancelled = true; };
  }, []);

  if (!data || !data.testo) return null;
  const hasAutore = data.autore && String(data.autore).trim().length > 0;

  return (
    <span
      className="hidden md:inline-flex items-baseline gap-2 text-left text-soft"
      data-testid="frase-del-giorno"
      aria-label="Frase del giorno"
    >
      <span className="text-line font-mono text-base self-center mx-1" aria-hidden>|</span>
      <span className="font-body italic text-[13px] leading-snug max-w-md" data-testid="frase-del-giorno-testo">
        {hasAutore ? `“${data.testo}”` : data.testo}
        {hasAutore && (
          <span
            className="ml-2 not-italic text-[11px] text-mute"
            data-testid="frase-del-giorno-autore"
          >
            — {data.autore}
          </span>
        )}
      </span>
    </span>
  );
}
